import { Helmet } from "react-helmet";
import Dashboard from "../../../layouts/Dashboard";
import { Button } from "@pushpress/pushpress-ui";
import { useCreateBillingPortalSession } from "../../../apis/billingApi.hooks";
import { toast } from "react-toastify";
import { defaultToastOptions } from "../../../utils/misc";

export const ACCOUNT_PAGE_TITLE = "My PushPress Plan";

function AccountLanding() {
  const { mutate: createPortalSession, isLoading } =
    useCreateBillingPortalSession();
  const returnUrl = window.location.href;

  return (
    <>
      <Helmet>{ACCOUNT_PAGE_TITLE}</Helmet>
      <Dashboard scrollableContent>
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-12">
          <p className="tw-mb-6 tw-text-gray-600">
            Manage your subscription and billing settings
          </p>

          <Button
            onClick={() => {
              createPortalSession(returnUrl, {
                onSuccess: (data) => {
                  if (data.url) {
                    window.open(data.url, "_blank");
                  } else if (data.message) {
                    toast.error(data.message, {
                      ...defaultToastOptions,
                    });
                  }
                },
                onError: () => {
                  toast.error("Failed to open Stripe Customer Portal", {
                    ...defaultToastOptions,
                  });
                },
              });
            }}
            isSubmitting={isLoading}
          >
            Manage Billing
          </Button>
        </div>
      </Dashboard>
    </>
  );
}

export default AccountLanding;
